module.exports = __webpack_public_path__ + "static/media/deleteTrash.442a2978.svg";